module.exports = __webpack_public_path__ + "6bbcb382f68a1f28d679e12a8a33873e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/meters/progress-reading.png
// module id = 1654
// module chunks = 0